import { IoClose } from "react-icons/io5";
import Icons from "../../assets/icon";
import Analytics from "../../firebase_services/analytics";
import { useSelector } from "react-redux";

const Logout = ({
  islogout,
  setIslogout,
  logout,
  dispatch,
  isHomePage,
  navigate,
}) => {
  const userData = useSelector((state) => state.app.userData.userData);
  return (
    <>
      <div
        className={`fixed inset-0 bg-primary bg-opacity-50 backdrop-blur-md transition-opacity duration-300 ${
          islogout ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      ></div>
      <div
        className={`fixed top-0 right-0 h-full w-full text-white flex p-3 sm:p-5 justify-center items-center transform ${
          islogout ? "translate-y-0" : "translate-y-full"
        } transition-transform duration-300`}
        onClick={() => setIslogout(false)}
      >
        <div className="rounded-xl relative bg-[#121212] w-full sm:w-2/4 xl:w-1/3 flex justify-center items-center flex-col p-5 sm:p-8 lg:p-10">
          <img
            src={Icons?.powerLogoutIcon}
            className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 mb-10 sm:mb-14 lg:mb-20"
            alt="logout"
          />
          <h1 className="uppercase text-secondary font-unboundedBold text-center text-xl sm:text-4xl lg:text-6xl mb-4 sm:mb-5 lg:mb-8">
            Are You Sure?
          </h1>
          <button
            className="bg-[#3D3D3D] absolute top-2 right-2 sm:top-3 sm:right-3 lg:top-5 lg:right-5 text-sm w-5 h-5 sm:w-5 sm:h-5 sm:text-lg lg:text-xl lg:w-7 lg:h-7 rounded-full text-secondary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
            onClick={() => setIslogout(false)}
          >
            <IoClose className=" transform transition-transform duration-300 group-hover:rotate-180" />
          </button>
          <div className="grid grid-cols-2 gap-x-2 w-full">
            <button
              type="button"
              className="bg-rejected py-1 sm:py-2 capitalize font-onestRegular text-xs sm:text-sm lg:text-base rounded-full border border-transparent hover:bg-transparent hover:border-rejected transition-all duration-200"
              onClick={() => {
                setIslogout(false);
              }}
            >
              no
            </button>
            <button
              type="button"
              className="bg-accepted py-1 sm:py-2 capitalize font-onestRegular text-xs sm:text-sm lg:text-base rounded-full border border-transparent hover:bg-transparent hover:border-accepted transition-all duration-200"
              onClick={async () => {
                await Analytics.trackLogout(userData?.role);
                logout();
                setIslogout(false);
                if (isHomePage) {
                  navigate("/");
                }
                dispatch({
                  type: "UPDATE_USER_DATA",
                  payload: { userData: "" },
                });
              }}
            >
              yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default Logout;
